import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import interiorEditorApi from "../services/interiorEditorApi";

export default function InteriorProjectsPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorText, setErrorText] = useState("");

  async function load() {
    try {
      setLoading(true);
      setErrorText("");

      const res = await interiorEditorApi.listProjects();
      setItems(res.items || []);
    } catch (err) {
      console.error("load projects error:", err);
      setErrorText(
        err?.response?.data?.error ||
          err?.message ||
          "Failed to load projects."
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function createProject() {
    try {
      const res = await interiorEditorApi.createProject({
        name: "New Interior Project",
        description: "",
        status: "draft",
        scene: {
  parameters: {
    boardThickness: 18,
    backThickness: 8,
    defaultCabinetDepth: 560,
  },
  nodes: [],
},
      });

      const id = res?.item?.id;
      if (id) {
        navigate(`/interior-editor/projects/${id}`);
      } else {
        load();
      }
    } catch (err) {
      console.error("create project error:", err);
      alert(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to create project."
      );
    }
  }

  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Interior Projects</h1>

        <button
          onClick={createProject}
          className="px-4 py-2 rounded bg-blue-600 text-white"
        >
          + New Project
        </button>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : errorText ? (
        <div className="border rounded p-4 text-red-600 bg-red-50">
          {errorText}
        </div>
      ) : (
        <div className="border rounded overflow-hidden">
  <table className="w-full text-sm">
    <thead className="bg-gray-100">
      <tr>
        <th className="text-left px-3 py-2">Name</th>
        <th className="text-left px-3 py-2">Description</th>
        <th className="text-left px-3 py-2">Status</th>
        <th className="text-left px-3 py-2">Updated</th>
        <th className="text-left px-3 py-2">Action</th>
      </tr>
    </thead>

    <tbody>
      {items.map((item) => (
        <tr key={item.id} className="border-t">
          <td className="px-3 py-2">{item.name}</td>

          <td className="px-3 py-2 text-gray-600">
            {item.description || "-"}
          </td>

          <td className="px-3 py-2">{item.status}</td>
          <td className="px-3 py-2">{item.updated_at}</td>

          <td className="px-3 py-2">
            <button
              onClick={() => navigate(`/interior-editor/projects/${item.id}`)}
              className="px-3 py-1 rounded border"
            >
              Open
            </button>
          </td>
        </tr>
      ))}

      {!items.length ? (
        <tr>
          <td className="px-3 py-4 text-gray-500" colSpan={5}>
            No projects found.
          </td>
        </tr>
      ) : null}
    </tbody>
  </table>
</div>
      )}
    </div>
  );
}